<i18n>
{
  "ja": {
    "OK": "WebP対応",
    "NG": "非対応"
  },
  "en": {
    "OK": "WebP OK",
    "NG": "NG"
  }
}
</i18n>

<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    share: Object,
  },
  computed: {
    datalist() {
      return [this.share.ok, this.share.ng]
    },
    titlelist() {
      return [this.$t('OK'), this.$t('NG')]
    },
  },
  mounted() {
    this.renderChart(
      {
        labels: this.titlelist,
        datasets: [
          {
            label: this.titlelist,
            backgroundColor: ['#3bafda', '#cccccc'],
            data: this.datalist
          }
        ],
      },
      {
        legend: {
          reverse: true,
        },
      }
    )
  }
}
</script>